module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "toc",
      "title": "Contents"
    }
  }, [_c('h2', {
    staticClass: "fmhead"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/front01"
    }
  }, [_vm._v("Note on Romanization")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/front02"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction"
    }
  }, [_vm._v("Introduction: Conceiving State Violence, Justice, and Transition in East Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Sung Chull Kim and N. Ganesan")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("1. Interpreting State Violence in Asian Settings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Vince Boudreau")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. From the Streets to the National Assembly: Democratic Transition and Demands for Truth about Kwangju in South Korea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Namhee Lee")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. Unsettled State Violence in Japan: The Okinawa Incident")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Hayashi Hirofumi")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Popular Views of State Violence in China: The Tiananmen Incident")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Jeffrey N. Wasserstrom and Kate Merkel-Hess")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Mass Atrocities in Cambodia under the Khmer Rouge Reign of Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Sorpong Peou")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Counterrevolutionary Violence in Indonesia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Douglas Kammen")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Getting Away with Murder in Thailand: State Violence and Impunity in Phatthalung")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Tyrell Haberkorn")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. The End of an Illusion: The Mendiola Massacre and Political Transition in Post-Marcos Philippines")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Rommel A. Curaming")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. The Four-Eights Democratic Movement and Political Repression in Myanmar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("Kyaw Yin Hlaing")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: Comparing State Violence and Reconciliation across East Asia")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_vm._v("N. Ganesan and Sung Chull Kim")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contributors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("List of Contributors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0